import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export function rollupActivitiesData(activitiesData) {
  var all = activitiesData.all,
    viewed = activitiesData.viewed,
    workedOn = activitiesData.workedOn;
  return {
    all: rollUpActivityItems(all),
    viewed: rollUpActivityItems(viewed),
    workedOn: rollUpActivityItems(workedOn)
  };
}
function rollUpActivityItems(activityItems) {
  // https://stackoverflow.com/a/49460534
  // creates an ordered 'hashmap' containing unique ids in the same order that the activity items appear
  var latestActivityItemsObjectWithLatestTimestamp = activityItems.reduce(function (acc, activityItem) {
    var deduplicateId = activityItem.object.deduplicateId || activityItem.object.id;
    var existingItem = acc[deduplicateId];
    if (existingItem) {
      var aggregatedItems = existingItem.aggregatedActivityItems || [];
      if (Date.parse(existingItem.timestamp) < Date.parse(activityItem.timestamp)) {
        activityItem.aggregatedActivityItems = [].concat(_toConsumableArray(aggregatedItems), [existingItem]);
        // remove the current activity for that id so when we add the more recent activity it is in the order that it appears
        delete acc[deduplicateId];
        acc[deduplicateId] = activityItem;
      } else {
        acc[deduplicateId].aggregatedActivityItems = [].concat(_toConsumableArray(aggregatedItems), [activityItem]);
      }
    } else {
      acc[deduplicateId] = activityItem;
    }
    return acc;
  }, {});
  return Object.values(latestActivityItemsObjectWithLatestTimestamp);
}

/**
 * This wont extract the last fragment, but that's ok as it should be the activity item connection fragment
 * @param key
 */
export var extractFragmentRegex = function extractFragmentRegex(key) {
  return new RegExp("fragment ".concat(fragmentName(key), " on ").concat(fragmentType(key), " ({(.|\\n)+?(?=fragment))"), 'gm');
};
var fragmentName = function fragmentName(key) {
  return key.charAt(0).toLowerCase() + key.slice(1);
};
var fragmentType = function fragmentType(key) {
  return key.charAt(0).toUpperCase() + key.slice(1);
};
export var activityRoot = function activityRoot(activity) {
  if (activity.myActivity) {
    return activity.myActivity;
  }
  return activity;
};
var SITE_ARI_PREFIX = 'ari:cloud:platform::site/';
var containerMapTypes = new Map([[SITE_ARI_PREFIX, 'SITE']]);
export function parseRootContainerARI(rootContainerARI) {
  // the "ID" portion of the ARI begins after the first '/'
  var ariSplitIndex = rootContainerARI.indexOf('/');
  return {
    ari: rootContainerARI,
    id: rootContainerARI.slice(ariSplitIndex + 1),
    type: containerMapTypes.get(rootContainerARI.slice(0, ariSplitIndex + 1)) || 'OTHER'
  };
}

// this is copied from @atlassian/ufo as it isn't exported

export function filtersToMetadata(filters) {
  var _filters$actors, _filters$containerIds, _filters$products, _filters$eventTypes, _filters$objectTypes, _filters$rootContaine;
  return _objectSpread(_objectSpread({}, filters), {}, {
    // These have V high cardinality, so using a length
    actors: (_filters$actors = filters.actors) === null || _filters$actors === void 0 ? void 0 : _filters$actors.length,
    containerIds: (_filters$containerIds = filters.containerIds) === null || _filters$containerIds === void 0 ? void 0 : _filters$containerIds.length,
    // comma separated lists
    products: (_filters$products = filters.products) === null || _filters$products === void 0 ? void 0 : _filters$products.join(','),
    eventTypes: (_filters$eventTypes = filters.eventTypes) === null || _filters$eventTypes === void 0 ? void 0 : _filters$eventTypes.join(','),
    objectTypes: (_filters$objectTypes = filters.objectTypes) === null || _filters$objectTypes === void 0 ? void 0 : _filters$objectTypes.join(','),
    rootContainerIds: (_filters$rootContaine = filters.rootContainerIds) === null || _filters$rootContaine === void 0 ? void 0 : _filters$rootContaine.join(',')
  });
}

/**
 * These fragments are the core of our query, without them it will always fail,
 * so we shouldn't remove them. It is possible that removing other offending fragments
 * will fix the error in these core fragments. (e.g. Field conflict)
 */
var RESTRICTED_FRAGMENTS = ['activity', 'all', 'myActivity', 'workedOn', 'viewed', 'activityItemConnection', 'activityItemEdge'];
export function filterInvalidFragments(invalidFragments, allFragments) {
  return invalidFragments.filter(function (fragment) {
    return !RESTRICTED_FRAGMENTS.includes(fragment);
  }).reduce(function (acc, invalidFragment) {
    return acc.replace(new RegExp("...".concat(invalidFragment, "\n"), 'g'), '').replace(extractFragmentRegex(invalidFragment), '');
  }, allFragments);
}
var IGNORED_ERROR_CLASSIFICATIONS = ['IncorrectAuthException'];
export function isEmptyActivitiesWithErrorsResponse(response) {
  if (!(response !== null && response !== void 0 && response.data) || !Array.isArray(response.errors)) {
    return false;
  }
  var filteredAggErrors = response.errors.filter(function (e) {
    return !e.extensions.classification || !IGNORED_ERROR_CLASSIFICATIONS.includes(e.extensions.classification);
  });
  return filteredAggErrors.length > 0 && isEmptyActivityResponse(response.data);
}
export function isEmptyActivityResponse(queryData) {
  var _activityRoot$all, _activityRoot$workedO, _queryData$activity;
  return !queryData.activity || ((_activityRoot$all = activityRoot(queryData.activity).all) === null || _activityRoot$all === void 0 || (_activityRoot$all = _activityRoot$all.edges) === null || _activityRoot$all === void 0 ? void 0 : _activityRoot$all.length) === 0 && ((_activityRoot$workedO = activityRoot(queryData.activity).workedOn) === null || _activityRoot$workedO === void 0 || (_activityRoot$workedO = _activityRoot$workedO.edges) === null || _activityRoot$workedO === void 0 ? void 0 : _activityRoot$workedO.length) === 0 && ((_queryData$activity = queryData.activity) === null || _queryData$activity === void 0 || (_queryData$activity = _queryData$activity.myActivity) === null || _queryData$activity === void 0 || (_queryData$activity = _queryData$activity.viewed) === null || _queryData$activity === void 0 || (_queryData$activity = _queryData$activity.edges) === null || _queryData$activity === void 0 ? void 0 : _queryData$activity.length) === 0;
}